import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchTemplateFailure,
  fetchTemplateSuccess,
} from "../slices/features/template";
import { RequestTypes } from "../types";
import { PAGINATION } from "src/constants/common";
import { setTemplateIsReset, setTemplateList, setTemplatePagination } from "../slices/features/templateList";
import { getTemplatePagination } from "../selectors/features/templateList";

const appservice = new AppService();

function* fetchTemplateSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchTemplate,
      baseUrl,
      id,
      meta
    );

    // Template list data for template button
    if (response?.data && meta?.page === PAGINATION.page) {
      const data = response?.data;

      const templatePagination: ReturnType<typeof getTemplatePagination> = yield select(
        getTemplatePagination as (state: TReduxState) => ReturnType<typeof getTemplatePagination>
      );

      const firstPageTemplateData = (templatePagination && templatePagination.length > 0)
        ? templatePagination.find(
          (t: { meta: { page: number, limit: number }, items: any[] }) => t?.meta?.page === 1
        ) : null;

      // Reset template list data if it is first page data
      const wasEmpty = !firstPageTemplateData?.items || firstPageTemplateData.items.length === 0;
      const firstPageDataChanged =
        wasEmpty ||
        firstPageTemplateData.items.length !== data.items.length ||
        firstPageTemplateData.items.some((it, idx) => it.id !== data.items[idx]?.id);

      if (firstPageDataChanged) {
        yield put(setTemplateList(data.items || []));
        yield put(setTemplatePagination([data]));

        if (!wasEmpty) {
          yield put(setTemplateIsReset(true));
        }
      }
    }

    yield put(
      fetchTemplateSuccess({
        ...response,
        items: [],
      })
    );

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchTemplateFailure({ statusCode, statusText }));
  }
}

export function* watchFetchTemplate() {
  yield takeLatest(RequestTypes.GET_TEMPLATE_REQUEST, fetchTemplateSaga);
}
